export default __webpack_public_path__ + "static/media/T2.jpg";